




























































































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import FileImportMixin from '@root/common/mixins/import/import.tsx';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import SpaceCard from './components/space-card.vue';
import * as routeNames from '../router-names';
import * as _ from 'lodash';
import { idNumber } from '@root/utils/validators';
import { verifyIdCard } from '@root/utils/validator-util';
import Utils from '@root/utils/common';
// 接口
import {
  queryParkingSpaceList,
  queryParkingSpaceAreaInfo,
  queryParkingSpaceTransferInfo,
  queryParkingSpaceTransfer,
  downloadTemplate,
  spaceExport,
  spaceDelete
} from '../../../api/parking-space-list';
// Enum
import {
  useTypeMap,
  categoryMap,
  useStatusMap,
  spaceTypeMap,
  statusMap
} from '../../../types/parking-space-management/dictionaries';
import checkAuthority from '@root/utils/check-authority';
import { isShiDaill } from '@root/utils/env';

import UserZhongtian from '../../fixed-car-management/property-car-list/compontents/user-zhongtian.vue';
import UserInfo from './components/user.vue';
@Component({
  name: 'ParkingSpaceList',
  components: {
    ParkingLotSearch,
    SpaceCard,
    UserInfo: window.VUE_APP_SERVER_CONFIG.APP_ENV === 'zhongtian' ? UserZhongtian : UserInfo
  }
})
export default class ParkingSpaceList extends Mixins(TableMixin, TableWidthMixin, FileImportMixin) {
  // 车位用途
  private useTypeList = Utils.toLabelVal(useTypeMap);
  // 车位类别
  private categoryList = Utils.toLabelVal(categoryMap);
  // 使用状态
  private useStatusList = Utils.toLabelVal(useStatusMap);
  // 车位类型
  private spaceTypeList = Utils.toLabelVal(spaceTypeMap);
  // 车位状态
  private statusList = Utils.toLabelVal(statusMap);

  // 身份证验证
  validatorIdNumber = idNumber;
  verifyIdCard = verifyIdCard;
  queryParkingSpaceAreaList: any = function() {}; // 区域列表防抖请求

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车位号',
        dataIndex: 'code',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '所在区域',
        dataIndex: 'areaName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车位类别',
        dataIndex: 'category',
        // customRender: (text: any) => categoryMap[text],
        width: 180
      },
      {
        title: '车位用途',
        dataIndex: 'useType',
        // customRender: (text: any) => useTypeMap[text],
        width: 180
      },
      {
        title: '使用状态',
        dataIndex: 'useStatus',
        customRender: (text: any) => useStatusMap[text],
        width: 180
      },
      {
        title: '泊车数量',
        dataIndex: 'number',
        width: 180
      },
      {
        title: '车位类型',
        dataIndex: 'spaceType',
        // customRender: (text: any) => spaceTypeMap[text],
        width: 180
      },
      {
        title: '车位状态',
        dataIndex: 'status',
        customRender: (text: any) => statusMap[text],
        width: 180
      },
      {
        title: '客户姓名',
        dataIndex: 'tenentName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 200
      }
    ];
  }
  canExport: boolean = true;
  currPage = 1;
  // table数据
  private tableData: any[] = [];
  // 统计数据
  private spaceTotal: any = {};

  // 所在区域列表
  private areaList: any = [];

  // 转让详情
  private transferDetail: any = {
    title: '车位转让',
    loading: false,
    parkId: '',
    visible: false,
    info: {},
    transferForm: null
  };

  // 加载中
  private tableLoading: boolean = false;

  private filterParam: any = {
    parkId: [], // 车场ID集合,多车场逗号分隔
    code: '', // 车位编号
    areaId: '', // 所在区域
    useType: [], // 车位用途
    category: [], // 车位类别
    useStatus: [], // 使用状态
    spaceType: [], // 车位类型
    status: [] // 车位状态
  };
  downloadLoading: boolean = false;
  isShow: boolean = false;

  private created() {
    this.fetchTableData();
    this.queryParkingSpaceAreaList = _.debounce(this.queryParkingSpaceAreaInfo, 500);
    this.transferDetail.transferForm = this.$form.createForm(this);
  }

  // 车场变化，请求区域
  @Watch('filterParam.parkId')
  onChangeParkId(newVal: string, oldVal: string) {
    this.queryParkingSpaceAreaList();
  }

  // 获取区域数据
  async queryParkingSpaceAreaInfo() {
    try {
      const { parkId } = this.filterParam;
      const { data } = await queryParkingSpaceAreaInfo({
        parkId: parkId.join(',')
      });
      this.areaList = data;
    } catch (error) {
      this.$message.error(error.msg);
      console.log('queryParkingSpaceAreaInfo error');
    }
  }

  // 点击搜索，默认current为1
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  // 清除搜索条件
  private onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList, // 车场ID集合,多车场逗号分隔
      code: '', // 车位编号
      areaId: '', // 所在区域
      useType: [], // 车位用途
      category: [], // 车位类别
      useStatus: [], // 使用状态
      spaceType: [], // 车位类型
      status: [] // 车位状态
    };
    this.search();
  }

  // 获取列表数据
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (this.isRefresh) this.currPage = 1;
    try {
      const options = {
        ...this.filterParam,
        parkId: this.filterParam.parkId.join(','),
        useType: this.filterParam.useType.join(','),
        category: this.filterParam.category.join(','),
        useStatus: this.filterParam.useStatus.join(','),
        spaceType: this.filterParam.spaceType.join(','),
        status: this.filterParam.status.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      };
      console.log('queryParkingSpaceList请求参数', options);
      const { status, code, msg, data } = await queryParkingSpaceList({ ...options });
      const { datas = [], totalNum = 0, total = {} } = data || {};
      this.tableData = datas;
      this.spaceTotal = total;
      this.total = Number(totalNum);
    } catch (error) {
      this.$message.error(error.msg);
    } finally {
      this.tableLoading = false;
    }
  }

  // 去详情
  private toDetail(id: string) {
    this.$router.push({
      name: routeNames.PARKING_SPACE_DETAIL,
      params: {
        id
      }
    });
  }

  // 去新增和修改
  private toUpdateCar(id: string) {
    if (id == '-1') {
      this.$router.push({
        name: routeNames.PARKING_SPACE_ADD,
        params: {
          id
        }
      });
    } else {
      this.$router.push({
        name: routeNames.PARKING_SPACE_UPDATE,
        params: {
          id
        }
      });
    }
    // this.$router.push({
    //   name: routeNames.PARKING_SPACE_UPDATE,
    //   params: {
    //     id,
    //   },
    // })
  }
  toUpdateEdit(row: any) {
    this.$router.push({
      name: routeNames.PARKING_SPACE_UPDATE,
      params: {
        id: row.pkSpaceId,
        ...row
      },
      query: {
        id: row.pkSpaceId,
        ...row
      }
    });
  }

  // 转让
  private async toTransfer(id: string, parkId: string) {
    this.transferDetail.visible = true;
    this.transferDetail.parkId = parkId;
    try {
      const { data } = await queryParkingSpaceTransferInfo({
        spaceId: id
      });
      this.transferDetail.info = data;
    } catch (error) {
      this.$message.error(error.msg);
      console.log('queryParkingSpaceTransferInfo error', JSON.stringify(error));
    }
  }

  // 转让弹框OK
  private async transferOk(e: any) {
    e.preventDefault();
    this.transferDetail.transferForm.validateFields((err: any, values: any) => {
      if (!err) {
        if (!this.transferDetail.info.code) return this.$message.error('请输入车位编号');
        this.insertTransfer(values);
      }
    });
  }

  private async insertTransfer(values: any) {
    this.transferDetail.loading = true;
    const { roomNum: roomNumber, phoneNum: phone, userName: name, cardNum: cardNumber, ...others } = values;
    const options = {
      roomNumber,
      phone,
      name,
      cardNumber,
      ...others,
      spaceId: this.transferDetail.info.spaceId,
      parkId: this.transferDetail.parkId,
      code: this.transferDetail.info.code
    };
    try {
      const { data } = await queryParkingSpaceTransfer({ ...options });
      this.$message.success('转让成功');
      this.fetchTableData();
      this.transferDetail.visible = false;
      this.transferDetail.transferForm.resetFields();
    } catch (error) {
      this.$message.error(error.msg);
      console.log('queryParkingSpaceTransfer error', JSON.stringify(error));
    } finally {
      this.transferDetail.loading = false;
    }
  }

  // 转让弹框cancel
  private transferCancel() {
    this.transferDetail.visible = false;
    this.transferDetail.transferForm.resetFields();
  }
  //下载
  private async downLoadTemplate() {
    try {
      this.downloadLoading = true;
      await downloadTemplate({}, '车位导入模板');
    } catch (e) {
      console.log('下载失败');
    } finally {
      this.downloadLoading = false;
    }
  }
  dropChange(val) {
    this.isShow = val;
  }
  private async downLoad() {
    try {
      this.canExport = false;
      const options = {
        ...this.filterParam,
        parkId: this.filterParam.parkId.join(','),
        useType: this.filterParam.useType.join(','),
        category: this.filterParam.category.join(','),
        useStatus: this.filterParam.useStatus.join(','),
        spaceType: this.filterParam.spaceType.join(','),
        status: this.filterParam.status.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      };
      this.canExport = true;
      await spaceExport(
        {
          ...options
        },
        '车位资源管理'
      );
    } catch (e) {
      this.canExport = true;
      console.log('couponExport', '导出失败');
    }
  }
  selectedRowKeys: any = [];
  get rowSelection() {
    return {
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        this.selectedRowKeys = selectedRowKeys;
        console.log(this.selectedRowKeys);
      },
      onSelect: (record: any, selected: any, selectedRows: any) => {
        // console.log(record, selected, selectedRows)
      },
      getCheckboxProps: record => ({
        props: {
          // disabled: record.useStatus == '02' || record.useStatus == '04',
          name: record.name
        }
      })
    };
  }
  async onMultiClearClick(recordCollection: any[] = []) {
    const _self = this;
    //this.tableLoading = true
    try {
      await spaceDelete({ spaceIds: _self.selectedRowKeys });
      _self.fetchTableData();
      _self.selectedRowKeys = [];
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      // _self.tableLoading = false
    }
  }

  handleUserChange(params) {
    this.transferDetail.transferForm.setFieldsValue(params);
  }

  beforeDestroy() {
    if (this.transferDetail.transferForm) {
      this.transferDetail.transferForm.resetFields();
    }
  }
}
